import { AlertCircle } from '@ensafely/checker-ui'
import { useUserSuspended } from './UserSuspendedContext'

export function UserSuspendedBanner() {
  const { isUserSuspended } = useUserSuspended()

  if (!isUserSuspended) return null

  return (
    <div className="w-full bg-red-50 border-b border-red-200 dark:bg-red-950/30 dark:border-red-800 px-4 py-2 flex items-center gap-2 text-red-800 dark:text-red-200 text-sm">
      <AlertCircle className="h-4 w-4 flex-shrink-0" />
      <span>
        Your account is suspended. You have read-only access. Contact your administrator to restore
        full access.
      </span>
    </div>
  )
}
